export const DEFAULT_START_TIME = 15;
export const DEFAULT_END_TIME = 18;
export const DEFAULT_HOUR_ADDITION = 3;
